import useAllQueuesQuery from "../apis/tryst/get-all-queues";
import { useMemo } from "react";
import { getQueueTypeFromKey } from "@elixir/utils";
import { getFilteredAppointmentList } from "ui";
import { getAptsForDoctor } from "../utils/appointment-utils";
import { AllQueuesData } from "@elixir/types";
import useQueueStore from "../stores/queue-store";

export default function useGetAllFiteredQueues() {
  const { data } = useAllQueuesQuery({ queueType: "all" });

  const queueFilter = useQueueStore((state) => state.queueFilter);
  const selectedDoctor = useQueueStore((state) => state.selectedDoctor);

  const filteredData = useMemo(() => {
    return (Object.keys(data || {}) as (keyof AllQueuesData)[]).reduce(
      (acc, key) => {
        const filteredQueueData = getFilteredAppointmentList({
          appointments: getAptsForDoctor({
            apts: data?.[key] || [],
            doctor_oid: selectedDoctor?.oid,
          }),
          queueFilter,
          queueType: getQueueTypeFromKey(key) as string,
        });
        return {
          ...acc,
          [key]: filteredQueueData,
        };
      },
      {} as AllQueuesData
    );
  }, [data, selectedDoctor?.oid, queueFilter]);

  return filteredData;
}
